module.exports = __webpack_public_path__ + "media/images/thumbs/biology/q_quiz_animal_cell_2-a0af5bd11aefca27b2ad88cd50390f56.jpg";